<template>
    <div
        class="help"
        @click.self="close"
    >
        <div class="help_content">
            <p
                class="close"
                @click="close"
            >
                ×
            </p>
            <p class="help_title">{{title}}</p>
            <div
                class="help_text"
                v-html="editedText"
            />
        </div>
    </div>
</template>
<script>
/**
 * ヘルプモーダル
 * 
 * [プロパティ]
 * title ... ヘルプのタイトル
 * text ... ヘルプの本文
 * refTitle ... 参照項目のタイトル
 * refText ... 参照項目の本文
 * 
 * [算出プロパティ]
 * editedText ... ヘルプの本文以下の項目を結合させたHTML
 * 
 * [イベント処理]
 * 背景の半透明divまたは「×」クリック時 ... this.$parent.showHelp = !this.$parent.showHelp
 * 
 * [利用例]
 * <help
 *     v-if="showHelp"
 *     @click="helpView"
 *     :title="helpTitle"
 *     :text="helpText"
 *     :ref-title="referenceTitle"
 *     :ref-text="referenceText"
 * />
 */
export default {
    name:"Help",
    props: {
        /**
         * ヘルプのタイトル
         */
        title:{
            type:String
        },
        /**
         * ヘルプの本文HTML
         */
        text:{
            type:String
        },
        /**
         * 参照項目のタイトルHTML
         */
        refTitle:{
            type:String
        },
        /**
         * 参照項目の本文HTML
         */
        refText:{
            type:String
        },
    },
    computed:{
        /**
         * ヘルプの本文以下の項目を結合させたHTML
         */
        editedText(){
            if(this.refTitle != undefined && this.refTitle != null){
                let return_text = this.text +"<p class='reference_title'>" + this.refTitle
                                    + "</p><div class='reference'>" + this.refText + "</div>"
                return return_text
            } else {
                return this.text
            }
        }
    },
    methods:{
        /**
         * 表示されているときにクリックされたら閉じる
         */
        close(){
            this.$emit('click')
        },
    }
}

</script>

<style scoped>
.help{
    z-index:1000;
    position:fixed;
    width:100vw;
    height:100vh;
    top:0px;
    left:0px;
    background-color: rgba(0,0,0,0.2);
    overflow-x: hidden;
    overflow-y: auto;
}
.help_content{
    box-sizing: border-box;
    z-index:1000;
    position:fixed;
    width:70%;
    height:auto;
    max-height:calc(100vh - 4rem);
    margin: 0 auto;
    top:2rem;
    left:calc((100vw - 70%) / 2);
    background-color: #FFF;
    border-radius: 5px;
    -webkit-box-shadow: 0 5px 15px 2px rgba(0, 0, 0, 0.5);
    box-shadow: 0 5px 15px 2px rgba(0, 0, 0, 0.5);
    padding:1rem 2rem;
}
.help_title{
    font-size:1.5rem;
    border-bottom:1px solid #ccc;
    margin:1rem 0;
}
.close{
    position: absolute;
    margin:0;
    top:1rem;
    right: 1rem;
    font-size: 1.5rem;
    font-weight: bold;
    text-shadow: 0px 0px 2px #ccc;
    color:#ccc;
    cursor: pointer;
}
.close:hover{
    color:#666;
    text-shadow: 0px 0px 2px #666;
}
.help_text{
    box-sizing: border-box;
    max-height:calc(100vh - 11rem);
    padding-bottom:0.5rem;
    overflow-y:auto;
}
.help_text >>> ul > li{
    margin-bottom:1em;
}
.help_text >>> table{
    margin: 1rem 0;
    border-collapse: collapse;
    width:100%;
}
.help_text >>> table th, .help_text >>> table td{
    box-sizing: border-box;
    padding:0.5rem;
    border:1px solid #ccc; 
}
.help_text >>> table th{
    text-align:center; 
}
.help_text >>> a{
    text-decoration: underline;
}
.help_text >>> a:hover{
    color:#ccc;
}
.help_text >>> a{
    text-decoration: underline;
}
.help_text >>> img{
    max-width:100%;
}
.help_text >>> .nomark{
    list-style:none;
}
.help_text >>> .sumitsuki:before{
    content: '【';
}
.help_text >>> .sumitsuki:after{
    content: '】';
}
.help_text >>> .reference_title{
    display:block;
    margin:0.5rem 1rem 0;
    padding:0.25rem 0.5rem;
    font-size:0.9em;
    background-color: #41B8D4;
    color:#FFF;
}
.help_text >>> .reference{
    margin:0 1rem;
    padding:0.5rem;
    font-size:0.9em;
    border:1px solid #41B8D4;
}
</style>